import React from 'react';
import { FaBroom, FaBrush, FaCodeCompare, FaStar, FaTrash } from 'react-icons/fa6';
import BreadcrumbsContainer from '../Breadcrumbs/BreadcrumbContainer';
import ActionButton from '../Buttons/ActionButton';
import { clearSelectedResultIds, selectResultIdsState } from '../../Store/resultSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface ResultActionButtonProps {
    imageId: string | undefined;
}

export default function ResultActionButtons(props: ResultActionButtonProps) {

    const { imageId } = props;

    const selectedResultIds = useSelector(selectResultIdsState);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // handle on click of compare button to navigate to the compare page
    // the compare page is located current path + results/{firstId}/compare/{secondId}
    const handleCompareClick = () => {
        // make sure location.pathname ends with /
        const path = window.location.pathname;
        if (!path.endsWith('/')) {
            navigate(`${path}/results/${selectedResultIds[0]}/compare/${selectedResultIds[1]}`);
        } else {
            navigate(`${path}results/${selectedResultIds[0]}/compare/${selectedResultIds[1]}`);
        }
    }

    const handleClearSelectionClick = () => {
        dispatch(clearSelectedResultIds());
    }

    const canCompare = selectedResultIds.length == 2
    const hasSelectedResult = selectedResultIds.length > 0

    return (
        <BreadcrumbsContainer>
            {canCompare && <ActionButton text='Compare' Icon={FaCodeCompare} onClick={handleCompareClick}/>}
            {hasSelectedResult && <ActionButton text='Clear Selection' Icon={FaBroom} onClick={handleClearSelectionClick}/>}
        </BreadcrumbsContainer>
    )
}